// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-header th {
  background-color: #e5f0f7;
  text-align: left;
  font-weight: 400;
  font-size: 12px;
  font-family: sans-serif;
  color: rgba(0, 0, 0, 0.87);
  padding: 2px;
  white-space: normal;
  overflow: hidden;
}

.full-width-table {
  width: 100%;
  margin: 0 auto;
  border: 0.5px solid var(--mp-icon-subdued-color);
  border-collapse: collapse;
  padding: 0;
  table-layout: fixed;
}
.full-width-table tbody tr {
  font-size: 0.75rem;
}
.full-width-table tbody td {
  color: rgba(0, 0, 0, 0.87);
  padding: 8px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.full-width-table th,
.full-width-table td {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  box-sizing: border-box;
}

.table-spacing {
  margin-top: 20px;
  width: 100%;
}

.actions {
  display: flex;
  align-items: center;
}
.actions .view-link,
.actions .download-link {
  margin-right: 10px;
  font-size: 0.85rem;
}
.actions .dropdown-icon {
  margin-left: 15px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white !important;
  padding-top: 5px;
  padding-bottom: 4px;
  border-bottom: 1px dashed #c4c3c3;
}
.card-header.collapsed {
  border-bottom: none;
}
.card-header strong {
  font-family: sans-serif;
  font-size: 0.85rem;
}

.detail-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  font-family: sans-serif;
  align-items: center;
  gap: 4rem;
  padding: 0 0;
}
.detail-row div {
  flex: 1 1 100%;
  margin-right: 0rem;
  font-size: 0.85rem;
}
.detail-row strong {
  margin-right: 0.5rem;
  font-weight: bold;
}

.grouped-container-details .headings-row,
.grouped-container-details .detail-row {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 8px;
  margin-bottom: 8px;
  align-items: center;
}
.grouped-container-details .headings-row {
  color: #545454;
  font-family: sans-serif;
  font-size: small;
  font-weight: normal;
}
.grouped-container-details .detail-row {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.grouped-container-details .detail-row:last-child {
  border-bottom: none;
}
.grouped-container-details .commodity-name {
  font-size: 12px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 150px;
}

.card-small {
  width: 100%;
  margin: 0 auto;
  font-size: 14px;
  border-radius: 0;
  border-color: #b5b5b5;
}

.headings-row {
  margin-top: 1px;
  gap: 4rem;
}

.card-body {
  margin-top: 0;
  padding: 0.5rem;
  padding-left: 1rem;
  padding-bottom: 0;
}

pagination-controls {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.booking-number {
  text-decoration: underline;
  color: var(--mp-view-bar-current-color);
  margin-left: 8px;
}

.commodity-name {
  display: inline-block;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.commodity-name-full {
  display: none;
}

.grouped-container-details .card-small:first-child {
  margin-top: -10px;
}

.sticky-note {
  position: fixed;
  top: 10px;
  right: 20px;
  background-color: #fffae6;
  padding: 10px 15px;
  border: 1px solid #ffcc00;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  font-size: 14px;
  color: #333;
}

.progress-bar {
  margin-top: 10px;
  margin-bottom: 0;
  height: 8px;
  background: #e9ecef;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}

.progress {
  height: 100%;
  background: #fdd81c;
  width: 100%;
  transition: width 0.2s ease-in-out;
}

@media (max-width: 840px) {
  .table-header th {
    font-size: 10px;
    padding: 6px;
    white-space: normal;
  }
  .full-width-table tbody td {
    font-size: 10px;
    padding: 6px;
  }
  .detail-row {
    gap: 0.5rem;
  }
  .grouped-container-details .headings-row {
    gap: 1rem;
  }
}
@media (min-width: 601px) and (max-width: 1200px) {
  .grouped-container-details .headings-row,
  .grouped-container-details .detail-row {
    grid-template-columns: repeat(10, 1fr);
    gap: 6px;
    font-size: 13px;
  }
}
@media (max-width: 600px) {
  .grouped-container-details .headings-row,
  .grouped-container-details .detail-row {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    gap: 0.3rem;
    font-size: 11px;
  }
  .grouped-container-details .headings-row span,
  .grouped-container-details .detail-row div {
    font-size: 11px;
    word-wrap: break-word;
    text-align: left;
    padding: 2px;
  }
  .commodity-name {
    max-width: 80px;
    white-space: normal;
    overflow: visible;
  }
  .card-small {
    padding: 0.5rem;
  }
  .card-header {
    flex-wrap: wrap;
    padding: 0.5rem;
  }
  .actions {
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 0.5rem;
  }
  .icon-action {
    font-size: 16px;
    margin-right: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Table/Table.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,0BAAA;EACA,YAAA;EACD,mBAAA;EACA,gBAAA;AACD;;AAEA;EACE,WAAA;EACA,cAAA;EACA,gDAAA;EACA,yBAAA;EACA,UAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEC;EACC,0BAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;AAAF;;AAGA;;EAEE,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;AACG;;EAEC,kBAAA;EACA,kBAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;AAAF;AAIE;EACE,mBAAA;AAFJ;AAIE;EACE,uBAAA;EACA,kBAAA;AAFJ;;AAKA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAFF;AAIE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AAFJ;AAIE;EACE,oBAAA;EACA,iBAAA;AAFJ;;AAME;;EAEE,aAAA;EACA,sCAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;AAHJ;AAKE;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAHJ;AAKE;EACE,cAAA;EACA,gCAAA;AAHJ;AAKE;EACE,mBAAA;AAHJ;AAOE;EACE,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AALJ;;AAQA;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AALF;;AAOA;EACE,eAAA;EACA,SAAA;AAJF;;AAMA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAHF;;AAKA;EACE,0BAAA;EACA,uCAAA;EACA,gBAAA;AAFF;;AAIA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AADF;;AAGA;EACE,aAAA;AAAF;;AAGE;EACE,iBAAA;AAAJ;;AAGA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EAEA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AADF;;AAGA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kCAAA;AACF;;AACA;EACE;IACE,eAAA;IACA,YAAA;IACA,mBAAA;EAEF;EACA;IACE,eAAA;IACA,YAAA;EACF;EAEA;IACE,WAAA;EAAF;EAEF;IACE,SAAA;EAAA;AACF;AAIA;EAEI;;IAEE,sCAAA;IACA,QAAA;IACA,eAAA;EAHJ;AACF;AAQA;EAEI;;IAEE,8DAAA;IACA,WAAA;IACA,eAAA;EAPJ;EAUE;;IAEE,eAAA;IACA,qBAAA;IACA,gBAAA;IACA,YAAA;EARJ;EAYA;IACE,eAAA;IACA,mBAAA;IACA,iBAAA;EAVF;EAeA;IACE,eAAA;EAbF;EAgBA;IACE,eAAA;IACA,eAAA;EAdF;EAiBA;IACE,eAAA;IACA,8BAAA;IACA,kBAAA;EAfF;EAkBA;IACE,eAAA;IACA,iBAAA;EAhBF;AACF","sourcesContent":[".table-header th {\n  background-color: #e5f0f7;\n  text-align: left; \n  font-weight: 400;\n  font-size: 12px;\n  font-family: sans-serif;\n  color: rgba(0, 0, 0, 0.87);\n  padding: 2px;\n white-space: normal;\n overflow: hidden;\n  \n}\n.full-width-table {\n  width: 100%; \n  margin: 0 auto; \n  border: 0.5px solid var(--mp-icon-subdued-color); \n  border-collapse: collapse;\n  padding: 0;\n  table-layout: fixed;\n\n  tbody tr {\n    font-size: 0.75rem; \n    \n}\n tbody td{\n  color: rgba(0, 0, 0, 0.87);\n  padding: 8px;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n }\n}\n.full-width-table th,\n.full-width-table td {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n  box-sizing: border-box; \n}\n\n.table-spacing {\n  margin-top: 20px;\n  width: 100%; \n}\n\n.actions {\n  display: flex;\n  align-items: center;\n   .view-link,\n  .download-link {\n    margin-right: 10px; \n    font-size: 0.85rem;\n  }\n\n  .dropdown-icon {\n    margin-left: 15px;\n  }\n}\n.card-header{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: white !important;\n  padding-top: 5px;\n  padding-bottom: 4px;\n  border-bottom: 1px dashed #c4c3c3;\n  \n  \n\n  &.collapsed{\n    border-bottom: none;\n  }\n  strong{\n    font-family: sans-serif;\n    font-size: 0.85rem;\n  }\n}\n.detail-row{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  font-family: sans-serif;\n  align-items: center;\n  gap: 4rem;\n  padding: 0 0;\n\n  div{\n    flex: 1 1 100%;\n    margin-right: 0rem;\n    font-size: 0.85rem;\n  }\n  strong{\n    margin-right: 0.5rem;\n    font-weight: bold;\n  }\n}\n.grouped-container-details{\n  .headings-row,\n  .detail-row{\n    display: grid;\n    grid-template-columns: repeat(10, 1fr);\n    gap: 8px;\n    margin-bottom: 8px;\n    align-items: center;\n  }\n  .headings-row{\n    color: #545454;\n    font-family: sans-serif;\n    font-size: small;\n    font-weight: normal;\n  }\n  .detail-row{\n    padding: 8px 0;\n    border-bottom: 1px solid #f0f0f0;\n  }\n  .detail-row:last-child{\n    border-bottom: none;\n  }\n  \n  // Make commodity name more compact\n  .commodity-name {\n    font-size: 12px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    max-width: 150px;\n  }\n}\n.card-small{\n  width: 100%;\n  margin: 0 auto;\n  font-size: 14px;\n  border-radius: 0;\n  border-color: #b5b5b5;\n}\n.headings-row{\n  margin-top: 1px;\n  gap: 4rem;\n}\n.card-body{\n  margin-top: 0;\n  padding: 0.5rem;\n  padding-left: 1rem;\n  padding-bottom: 0;\n}\n\npagination-controls {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n.booking-number{\n  text-decoration: underline;\n  color: var(--mp-view-bar-current-color);\n  margin-left: 8px;\n}\n.commodity-name{\n  display: inline-block;\n  max-width: 300px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n}\n.commodity-name-full{\n  display: none;\n}\n.grouped-container-details {\n  .card-small:first-child {\n    margin-top: -10px;  \n  }\n}\n.sticky-note {\n  position: fixed;\n  top: 10px;\n  right: 20px;\n  // transform: translateX(-50%);\n  background-color: #fffae6;\n  padding: 10px 15px;\n  border: 1px solid #ffcc00;\n  border-radius: 5px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  font-size: 14px;\n  color: #333;\n}\n.progress-bar{\n  margin-top: 10px;\n  margin-bottom: 0;\n  height: 8px;\n  background: #e9ecef;\n  border-radius: 5px;\n  overflow: hidden;\n  position: relative;\n}\n.progress{\n  height: 100%;\n  background: #fdd81c;\n  width: 100%;\n  transition: width 0.2s ease-in-out;\n}\n@media (max-width: 840px) {\n  .table-header th {\n    font-size: 10px; \n    padding: 6px;\n    white-space: normal;\n  }\n\n  .full-width-table tbody td {\n    font-size: 10px; \n    padding: 6px;\n  }\n\n  .detail-row {\n    gap: 0.5rem; \n}\n.grouped-container-details .headings-row{\n  gap:1rem;\n}\n}\n\n// Medium screens - adjust grid for better fit\n@media (min-width: 601px) and (max-width: 1200px) {\n  .grouped-container-details {\n    .headings-row,\n    .detail-row {\n      grid-template-columns: repeat(10, 1fr);\n      gap: 6px;\n      font-size: 13px;\n    }\n    \n\n  }\n}\n@media (max-width: 600px) {\n  .grouped-container-details {\n    .headings-row,\n    .detail-row {\n      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr; \n      gap: 0.3rem; \n      font-size: 11px;\n    }\n\n    .headings-row span,\n    .detail-row div {\n      font-size: 11px; \n      word-wrap: break-word; \n      text-align: left; \n      padding: 2px;\n    }\n  }\n\n  .commodity-name {\n    max-width: 80px; \n    white-space: normal; \n    overflow: visible; \n  }\n  \n\n\n  .card-small {\n    padding: 0.5rem; \n  }\n\n  .card-header {\n    flex-wrap: wrap; \n    padding: 0.5rem; \n  }\n\n  .actions {\n    flex-wrap: wrap; \n    justify-content: space-between; \n    margin-top: 0.5rem; \n  }\n\n  .icon-action {\n    font-size: 16px; \n    margin-right: 5px; \n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
